import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiX, FiArrowRight } = FiIcons;

const PainPromise = () => {
  const painPoints = [
    "You're falling behind as AI transforms every industry",
    "Complex tutorials waste your time with technical jargon",
    "You need practical skills, not theory from 20-something YouTubers"
  ];

  return (
    <section className="py-16 bg-slate-50 dark:bg-slate-800">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 dark:text-white mb-8">
            Tired of Being Left Behind by AI?
          </h2>
          
          <div className="space-y-4 mb-12">
            {painPoints.map((pain, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, x: -30 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="flex items-center justify-center text-left"
              >
                <SafeIcon icon={FiX} className="w-6 h-6 text-red-500 mr-4 flex-shrink-0" />
                <span className="text-lg text-slate-700 dark:text-slate-300">{pain}</span>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/20 dark:to-blue-900/20 p-8 rounded-xl border-2 border-green-200 dark:border-green-700"
          >
            <div className="flex items-center justify-center mb-4">
              <SafeIcon icon={FiArrowRight} className="w-8 h-8 text-green-600 dark:text-green-400" />
            </div>
            <h3 className="text-2xl font-bold text-slate-800 dark:text-white mb-4">
              Here's How We Fix This
            </h3>
            <p className="text-lg text-slate-700 dark:text-slate-300">
              <strong>GenXDojo teaches AI the way you learn best:</strong> Practical, step-by-step videos that respect your time and intelligence, designed by professionals who understand your world.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default PainPromise;